import React, { useState, useMemo, useEffect } from 'react';
import { ResultCard } from '../finance/shared';

const StreamingCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [services, setServices] = useState<Record<string, boolean>>({
    netflix: false, prime: false, disney: false, hbo: false
  });

  const prices: Record<string, number> = { netflix: 39.9, prime: 14.9, disney: 33.9, hbo: 34.9 };

  const total = useMemo(() => {
    return Object.entries(services).reduce((sum, [s, active]) => active ? sum + prices[s] : sum, 0);
  }, [services]);

  useEffect(() => {
    onResultChange([{ label: 'Total Mensal', value: `R$ ${total.toFixed(2)}` }]);
  }, [total]);

  const toggle = (s: string) => setServices(prev => ({ ...prev, [s]: !prev[s] }));

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
          {Object.keys(prices).map(s => (
            <button key={s} onClick={() => toggle(s)} className={`p-4 rounded-xl border-2 font-bold transition-all ${services[s] ? 'border-indigo-500 bg-category-sim text-category-sim' : 'border-theme-border text-theme-muted'}`}>
              {s.charAt(0).toUpperCase() + s.slice(1)}
              <div className="text-xs opacity-60">R$ {prices[s].toFixed(2)}</div>
            </button>
          ))}
        </div>
        <ResultCard title="Total Mensal" value={`R$ ${total.toFixed(2)}`} color="indigo" />
      </div>
    </div>
  );
};

export default StreamingCalculator;
